   <template>
<div>
       <Header/>

<!--End mainmenu area--> 

<!--Start breadcrumb area-->

<section class="breadcrumb-area" v-bind:style="{backgroundImage: 'url('+this.pagebanner+ ')' }">
	<div class="container text-center">
		<h1 v-if="pagedata">{{ $i18n.locale == 'en' ? pagedata.page_entitle:pagedata.page_artitle }}</h1>
		<span class="border"></span>
	</div>
</section>
<!--End breadcrumb area-->
         
<!--Start breadcrumb bottom area--> 
<section class="breadcrumb-bottom-area">
    <div class="container">
        <div :class="$i18n.locale == 'en' ?'right pull-left': 'right pull-right'">
            <a href="#"></a>    
        </div>
        <div class="right pull-left">
            <ul>
               <li><a :href="$i18n.locale == 'en' ? '../../../../en/': '../../../../ar/'">{{ $i18n.locale == 'en' ? 'Home':'الرئيسية' }}</a></li>
               <li>></li>
                <li><a href="#">{{ $i18n.locale == 'en' ? pagedata.page_entitle:pagedata.page_artitle }}</a></li>

                
            </ul>    
        </div>        
    </div>    
</section>         
<!--End breadcrumb bottom area-->
         
<!--Start faq content area-->
  <p v-html="$i18n.locale == 'en' ? pagedata.pagecontenten: pagedata.pagecontentar"> {{ $i18n.locale == 'en' ?  pagedata.pagecontenten: pagedata.pagecontentar  }}</p>  
  <section class="our-team-area">
    <div class="container">
        <div class="row">
                            <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalCenterTitle"></h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">

                                <form id="register">

                                    <div class="form-group row">
                                        <label for="staticEmail" class="col-sm-2 col-form-label">{{
                                                $i18n.locale == 'العربية' ?'عنوان البريد الالكترونى':'Email Address' }}</label>
                                        <div class="col-sm-10">
                                            <input type="text" class="form-control" id="inputemail" v-model="registeremail" placeholder="Email">

                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="inputPassword" class="col-sm-2 col-form-label">
                                          {{  $i18n.locale == 'العربية' ? 'كلمة السر':'Password' }}

                                            </label>
                                        <div class="col-sm-10">
                                            <input type="password" class="form-control" id="inputPassword" v-model="registerpassword" placeholder="Password">
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="inputmobile" class="col-sm-2 col-form-label">Mobile</label>
                                        <div class="col-sm-10">
                                            <input type="text" class="form-control" id="inputmobile" placeholder="Mobile" v-model="registermobile">
                                        </div>
                                    </div>


                                    <button  @click="showmore()" type="button" class="btn btn-primary" data-dismiss="modal">
                                        {{  $i18n.locale == 'العربية' ? 'سجل الأن':'Subscribe Now' }}
                                        </button>


                                </form>
                                <form id="signin" method="POST" style="display: none;" action="">

                                    <div class="form-group row">
                                        <label for="staticEmail" class="col-sm-2 col-form-label">{{
                                                $i18n.locale == 'العربية' ?'عنوان البريد الالكترونى':'Email Address' }}</label>
                                        <div class="col-sm-10">
                                            <input type="text" class="form-control" id="inputemailsignin" placeholder="Email" v-model="signinemail">

                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="inputPassword" class="col-sm-2 col-form-label">
                                            {{  $i18n.locale == 'العربية' ? 'كلمة السر':'Password' }}

                                        </label>                                        <div class="col-sm-10">
                                            <input type="password" class="form-control" id="inputPasswordsignin" placeholder="Password" v-model="signinpassword">
                                        </div>
                                    </div>




                                    <button  @click="showmoresignin()" type="button" class="btn btn-primary" data-dismiss="modal">Sign In</button>


                                </form>
                            </div>
                            <div class="modal-footer">
                                <p style="color:red" v-if="subscribeerror"> {{ subscribeerror }}</p>
<!--                                <button @click="showmore()"  type="button" class="btn btn-primary">Save changes</button>-->

                                <a style="font-weight: bold"  @click="showsignin()" type="button" >
                                    <label for="inputPassword" class="col-sm-2 col-form-label">{{$i18n.locale == 'العربية' ? 'تسجيل الدخول':'SignIn'}}</label>
                                     </a> |
                                <a style="font-weight: bold"  @click="showregister()" type="button"  >Register</a>
                            </div>
                        </div>
                    </div>
                </div>

            
                        <div class="col-lg-9 col-md-8 col-sm-12 col-xs-12">
                <div class="product-detail-content">
                    <!--Start product content box-->
                    <div class="product-content-box">
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <div class="img-box">
                                                        <iframe :src="videodataonelink" class="embed-responsive-item" allow="autoplay; fullscreen" allowfullscreen=""   frameborder="0"></iframe>
                                </div>
                                <span style="padding-top: 1%;padding-bottom: 1%;padding-left: 2%;padding-right: 2%;background: #688ec5;color: #fff;border: 0px solid #160f09;" >{{ videodataonename }}</span>
                                <div class="buttons" style="width: 60%;margin-top:3%;">
                                   
                                         <button style="padding-top: 1%;padding-bottom: 1%;padding-left: 2%;padding-right: 2%;background: #688ec5;color: #fff;border: 0px solid #160f09;"  type="button"  data-toggle="modal" data-target="#exampleModalCenter">
                                                   
                                                 
                                                    {{$i18n.locale =='en'?'More Lessons Subscribe Now':'المزيد من الدروس سج'}}
                                                </button>
                                        
                                </div>
                            </div>

                        </div>    
                    </div>

                </div>   
            </div>

            
            

        </div>
    </div>
</section>         

<!--End faq content area-->
	<!--Start slogan area-->
<section class="slogan-area">
    <div class="container">
        <div class="title pull-center">
            <h2>{{ $i18n.locale == 'en' ? pagefooteren: pagefooterar  }}</h2>    
        </div>
        <div class="buttons pull-right">
        </div>
    </div>    
</section>
<!--End slogan area-->
<!--Start footer area-->  

   
            <Footer/>
 </div>
    </div>
</template>

<script>
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery-1.11.1.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.bxslider.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.countTo.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.appear.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/owl.carousel.min.js";

import  "https://wafrafrontend.marketequityinc.com/src/assets/js/validate.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.mixitup.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.easing.min.js";
import "http://maps.google.com/maps/api/js?sensor=true";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/gmaps.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/map-helper.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.fitvids.js";


import "https://wafrafrontend.marketequityinc.com/src/assets/fancyapps-fancyBox/source/jquery.fancybox.pack.js";		

import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.tools.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.revolution.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.actions.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.carousel.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.kenburn.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.layeranimation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.migration.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.navigation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.parallax.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.slideanims.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.video.min.js";




import "https://wafrafrontend.marketequityinc.com/src/assets/js/custom.js";
</script>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'Home',
    title: 'Home',
    data() {
        return {
            langs: ['en', 'ar'],
           
            homepageblocks: '',
            homeblock1: null,
            homeblockimage1: null,
            homepageblocksicons: [],
            homepageblocksicons3: [],
            homepageblocks2: '',
            ceomessage: '',
            successstories: '',
            slide1image:'',
            slide2image:'',
            slide3image:'',
            techanalysis:'',
            pagedata:'',
            pagebanner:'',
            crosses:'',
            currencydata:'',
            learningcoursesar:'',
            learningcoursesen:'', 
            learningcoursesen:'',
             learningcoursesar:'',
            videodata:'',
            videodataonelink:'',
            videodataonename:'',
            exampleModalCenter : '',
            registeremail:'',
            registerpassword:'',
            registermobile:'',
            signinemail:'',
            signinpassword:'',
            subscribeerror:null,
            pagenameroute:'',
            
            

        }
    },
    components: {
        Header,
        Footer
    },
    beforeMount() {
                this.exampleModalCenter =false;

          var pathvalues = (this.$route.path).split("/");
        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'ar';
        }
        this.loadpagedata('learningvideos');

        // this.$i18n.locale=pathvalues[1];
        this.pagenameroute=pathvalues[3];
        this.loadvideosdata(this.pagenameroute)

    },
    mounted() {
        
        this.loadpagedata('learningvideos');
        this.loadvideosdata(this.pagenameroute);
        this.loaddata();
       
    },

    methods: {
        loaddata() {

            this.$axios.get("loadheaderdata",
            )
                .then(res => {
                    if (res) {

                       
                        this.pagefooteren = res.data.sitesettings[0].pagefooteren;
                        this.pagefooterar = res.data.sitesettings[0].pagefooterar;
                      
                    }
                });
        },
       loadpagedata(pagename) {
            this.$axios.get("loadpagedata", {
                params: {
                    pagename: pagename
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                          if (res.data.code == 200) {
                        this.pagedata = res.data.pagedata[0];
                        this.pagebanner=this.serverurl+'/public/pagebanners/'+res.data.pagedata[0].pagebanner;
                          }
                        else{

                            this.$router.push({ name: 'NotFound' })
                        }
                    }
                });
            

        },

 
 showsignin(){
            document.getElementById("signin").style.display = "block";
            document.getElementById("register").style.display = "none";

        },
        showregister(){
            document.getElementById("signin").style.display = "none";
            document.getElementById("register").style.display = "block";

        },
        showmore(){


            this.$axios.get("subscribenew", {
                params: {

                    email: this.registeremail,
                    password: this.registerpassword,
                    mobile: this.registermobile,
                    coursevideoid: this.pagenameroute,

                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                        if(res.data.code==200) {
                            document.getElementById("onerow").style.display = "none";
                            document.getElementById("morevideos").style.display = "block";
                        }
                    else{
                            this.exampleModalCenter=true;
                            this.showregister();
                        this.subscribeerror="Please Enter Valid Email/Password"
                        }


                    }
                });
        },
        showmoresignin(){



            this.$axios.get("subscribecheck", {
                params: {

                    email: this.signinemail,
                    password: this.signinpassword,
                                   }
            })
                .then(res => {
                    if (res) {
                        console.log(res)

                        if(res.data.code==200) {
                            document.getElementById("onerow").style.display = "none";
                            document.getElementById("morevideos").style.display = "block";
                        }
                        else{

                            this.showsignin()
                            this.subscribeerror="Please Enter Valid Email/Password"
                        }

                    }
                });
        },
        loadvideosdata(courseid) {
            this.$axios.get("http://devbackup.marketequityinc.com/loadcoursevideoswafra", {
                params: {
                    courseid: courseid
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                        this.pagedata = res.data.pagedata[0];
                        this.videodata = res.data.videodata;
                        this.videodataonelink=res.data.videodataone.videolink
                        this.videodataonename=res.data.videodataone.name

                    }
                });
        }

    
} }
</script>
<style>
#div1::after{
    clear: none!important;
    
}
.carousel {
  background: #2f435700!important;
}
    
</style>
